import PublicLayout from './layout/PublicLayout.vue'

const publicRoutes = [
  {
    path: '/public',
    component: PublicLayout,
    children: [
      {
        path: 'auth/account-link',
        name: 'AccountLink',
        component: () => import('@/views/public/AccountLink.vue'),
        meta: {
          title: 'Account Link',
        },
      },
      {
        path: 'appointment-postpone',
        name: 'AppointmentPostpone',
        component: () => import('@/views/public/AppointmentPostpone.vue'),
      },
      {
        path: 'appointment-landing',
        name: 'AppointmentLanding',
        component: () => import('@/views/public/AppointmentLanding.vue'),
      },
      {
        path: 'appointment-walkin',
        name: 'AppointmentWalkin',
        component: () => import('@/views/Appointment.vue'),
      },
      {
        path: 'patient-create',
        name: 'PatientCreate',
        component: () => import('@/views/PatientCreate.vue'),
      },
      {
        path: 'chain-promotion',
        name: 'ChainPromotion',
        component: () => import('@/views/ChainPromotion.vue'),
      },
      {
        path: 'bf-showcase',
        name: 'BF_Album',
        component: () => import('@/views/BFAlbum.vue'),
      },
      {
        path: '/feedback', // TODO: หลังจากทำ feedback ให้สามารถส่งซ้ำได้ ให้ย้าย path ไปเป็น /public/feedback
        name: 'Feedback',
        component: () => import('@/views/OPDFeedback.vue'),
      },
      // {
      //   path: '/feedbackV2',
      //   name: 'FeedbackV2',
      //   component: () => import('@/views/OPDFeedbackV2.vue'),
      // },
      // {
      //   path: 'appointment-walkin',
      //   name: 'AppointmentWalkin',
      //   component: () => import('@/views/Appointment.vue'),
      // },
    ],
  },
]

export default publicRoutes
